import React, { useEffect, useState, FC } from "react"
import { Tabs, Tab, TabPanel, TabList } from "react-tabs"
import "react-tabs/style/react-tabs.css"
import PendingApprovalTable from "./table/PendingApproval"
import ApprovalTable from "./table/Approval"
import RejectedTable from "./table/Rejected"
import axios from "axios"
import { isAuth } from "../../../auth/ProtectedRoute"

const InstructorTab: FC = () => {
  const [pendingTotal, setPendingTotal] = useState<number>(0)
  const [approvedTotal, setApprovedTotal] = useState<number>(0)
  const [rejectedTotal, setRejectedTotal] = useState<number>(0)

  useEffect(() => {
    // Fetch Pending Count
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `learning/instructors/pending`,
      headers: { Authorization: `Bearer ${isAuth()}` },
    }).then(res => {
      if (res.data.response === true && res.status === 200) {
        setPendingTotal(res?.data?.data?.pagination?.total || 0)
      }
    }).catch(err => console.log(err));

    // Fetch Approved Count
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `learning/instructors/approved`,
      headers: { Authorization: `Bearer ${isAuth()}` },
    }).then(res => {
      if (res.data.response === true && res.status === 200) {
        setApprovedTotal(res?.data?.data?.pagination?.total || 0)
      }
    }).catch(err => console.log(err));

    // Fetch Rejected Count
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `learning/instructors/rejected`,
      headers: { Authorization: `Bearer ${isAuth()}` },
    }).then(res => {
      if (res.data.response === true && res.status === 200) {
        setRejectedTotal(res?.data?.data?.pagination?.total || 0)
      }
    }).catch(err => console.log(err));
  }, []);

  return (
    <Tabs style={{ flex: 1 }}>
      <TabList
        style={{
          borderBottom: "none",
          margin: 0,
          display: "flex",
          alignItems: "center"
        }}
      >
        <Tab className="project-tab">
          <span className="tab-label">Pending Approval</span>
          <span className="tab-count">{pendingTotal}</span>
        </Tab>
        <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
        <Tab className="project-tab">
          <span className="tab-label">Approved</span>
          <span className="tab-count">{approvedTotal}</span>
        </Tab>
        <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
        <Tab className="project-tab">
          <span className="tab-label">Rejected</span>
          <span className="tab-count">{rejectedTotal}</span>
        </Tab>
      </TabList>
      <TabPanel className="pending-button">
        <PendingApprovalTable getPendingTotal={setPendingTotal} />
      </TabPanel>
      <TabPanel className="approval-button">
        <ApprovalTable getApprovedTotal={setApprovedTotal} />
      </TabPanel>
      <TabPanel className="approval-button">
        <RejectedTable getRejectedTotal={setRejectedTotal} />
      </TabPanel>
    </Tabs>
  )
}
export default InstructorTab
